/**
 * Shared constants for API operations
 */

/** Maximum number of tokens for model responses in the demo app */
export const DEMO_MAX_TOKENS = 4096;
